module.exports = __webpack_public_path__ + "img/xgmm.6f550baf.png";